module.exports = __webpack_public_path__ + "media/img/uploads/event-featured-thumb-01-8c48a9be9da3254c810f131f04dbe6d1.jpg";